import React from 'react'
import { Button, Card, Col, Divider, Row, Select } from 'antd'
import Image from '../../../components/Image'
import AppLink from '../../../components/AppLink'
import { ProductSetContentsPopover } from '../../../components/ProductSetContents'
import { range } from '../../../arrays'

const { Option } = Select

export default function Step1({
  product,
  cancelCount,
  onCancelCountChange,
  onNextClick
}) {
  if (!product) return null

  return (
    <>
      <p className="text-bold mb-2">解約する商品</p>

      <div className="mb-3">
        <Card size="small">
          <Row gutter={16} type="flex" align="middle">
            <Col span={3}>
              <Image src={product.image ? product.image.imageName : null} />
            </Col>
            <Col span={12}>
              <p className="mb-1">
                <AppLink to={`/products/${product.productId}`}>
                  {product.productTitle}
                </AppLink>
              </p>
              <div>
                {product.sexName}
                <Divider type="vertical" />
                {product.size}
                <Divider type="vertical" />
                {product.pNo}
              </div>
              {product.isSet && (
                <div className="mt-2">
                  <ProductSetContentsPopover
                    items={product.setContents}
                    header={product.title}
                  />
                </div>
              )}
            </Col>
            <Col span={4}>
              <span className="mr-2">レンタル中</span>
              <span>{product.status.rental}</span>
            </Col>
            <Col span={5}>
              <Row gutter={8} type="flex" align="middle">
                <Col span={12} className="text-right">解約数</Col>
                <Col span={12}>
                  <Select
                    style={{ width: '100%' }}
                    value={cancelCount}
                    onChange={onCancelCountChange}
                  >
                    {range(product.status.rental).map(num => (
                      <Option key={num} value={num}>{num}</Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>

      <Divider />

      <div className="text-right">
        <Button
          type="primary"
          onClick={onNextClick}
          disabled={cancelCount === 0}
        >
          解約内容を確認する
        </Button>
      </div>
    </>
  )
}
